<template>
    <header :class="['creator-header']" :disabeld=" $store.state.merchant_disabeld">
        <div class="header">
            <div  class="title">
                <h2>Creator Management</h2>
                <queue-progress />
            </div>
            <!-- <div class="usage-block" v-if="show_usage">
                <Usage :canShowPlan="!cantEditCompany" :only_creator="is_link_only"/>
                <p class="ui-usage-text">
                    <a :href="`mailto:${$store.state.mail_to}?subject=${$store.state.user_data.merchant_account.merchant_display_name} - Upgrade creator limit&body=Please provide your name and contact info. A representative will contact you in 1-2 business days.`" target="_blank">Contact us</a> 
                to upgrade your plan.</p>
            </div> -->
            <!-- 10440 hide @mouseleave="is_show_msg = false"  @mouseover="is_show_msg = true"first -->
            <div :class="['share-link', $store.state.merchant_disabeld && 'disabeld-box']" >
                <span @click="share">Share Invite Link</span>
                <!-- <i><SvgIcon name="question" /></i> -->
            </div>
            <DatePicker  @update-date="updateDate" />
        </div>
        <slide-up-down v-model="is_show_msg" :duration="300">

            <div class="msg">
                <SvgIcon name="flag" />
                <p>Creators that are "Pending" but not "Active" have not joined Motom yet and cannot activate their storefront until they do so. Remind them by sharing the invite link.</p>
            </div>
        </slide-up-down>
    </header>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon.vue';
import DatePicker from '@/components/ui/DatePicker.vue';
import Usage from '@/components/ui/Usage.vue';

export default {
    name: 'CreatorHeader',

    props:{
        steps: {
            type: Array,
            required: false,
            default: () => [],
        },
        active: {
            type: Number,
            required: false,
            default: 0,
        },
    },

    data() {
        return {
            is_show_msg: false,
        }
    },

    computed: {
        is_link_only() {
            return this.$store.state.user_data?.merchant_account?.platform_type === 'linkonly';
        },
        show_usage() {
            return this.$store.state.current_creator_count >= this.$store.state.creator_max_count * 0.9;
        },
    },

    components: {
        SvgIcon,
        DatePicker,
        Usage,
    },


    methods: {
        updateDate(obj) {
            this.$emit('update', obj);
        },

        share() {
            if(!this.$store.state.merchant_disabeld){
                const obj = {};
                obj.type = 'invite';
                this.EventBus.emit('open-share', obj);
            }
        },
    }
}
</script>
<style lang="scss">
    .creator-header {

        .usage-block{
            display: flex;
            gap:6px;
            justify-items: flex-end;
            align-items: center;
            .ui-usage-large{
                margin: 0;
            }
            .ui-usage-text{
                margin:0;
            }
        }

        .disabeld-box{
            opacity: .5;
            .share-link {
                cursor: default !important;
            }
        }

        .header {
            display: flex;
            align-items: center;
            gap:16px;

            .title {
                flex: 1;
                display: flex;
                align-items: center;
                
                & > h2 {
                    font: var(--font-demi-36);
                    color: black;
                }
            }

            .share-link {
                display: flex;
                align-items: center;
                cursor: pointer;
                
                span {
                    color: var(--dark-blue);
                    font: var(--font-fg-12);
                }

                i {
                    height: 14px;
                    width: 14px;
                    margin-left: 8px;

                    svg {
                        height: 100%;
                        width: 100%;
                        display: block;
                        color: var(--dark-blue);
                    }
                }
            }

            .ui-button {
                border-color: var(--black-20);
                background-color: var(--black-10);
            }

        }

        
        .msg {
            display: flex;
            align-items: center;
            padding: 9px 12px;
            color: white;
            background-color: var(--neutral-60);
            border-radius: 6px;
            position: relative;
            margin-top: 10px;

            &:after {
                bottom: 100%;
                right: 375px;
                border: solid transparent;
                content: "";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
                border-color: rgba(0, 0, 0, 0);
                border-bottom-color: var(--neutral-60);
                border-width: 6px;
            }

            p {
                flex: 1;
                padding: 0 8px;
            }


            .svg-icon--flag {
                height: 14px;
                width: 14px;
                fill: white;
            }

            .close {
                cursor: pointer;
                height: 12px;
                width: 12px;

                svg {
                    height: 100%;
                    width: 100%;
                    display: block;
                    fill: white;
                }
            }
        }
    }
</style>